/**
 * @generated SignedSource<<5492c795e1ca82fbb7640ae8a9b45d6c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type NodeInput = {
  id: string;
};
export type InterstitialNotificationsTableArchiveMutation$variables = {
  input: NodeInput;
};
export type InterstitialNotificationsTableArchiveMutation$data = {
  readonly archiveInterstitialNotification: {
    readonly isArchived: boolean;
  };
};
export type InterstitialNotificationsTableArchiveMutation = {
  response: InterstitialNotificationsTableArchiveMutation$data;
  variables: InterstitialNotificationsTableArchiveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArchived",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InterstitialNotificationsTableArchiveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GraphQLInterstitialNotification",
        "kind": "LinkedField",
        "name": "archiveInterstitialNotification",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InterstitialNotificationsTableArchiveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GraphQLInterstitialNotification",
        "kind": "LinkedField",
        "name": "archiveInterstitialNotification",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a20b2f934554cab164b3622e506c7766",
    "id": null,
    "metadata": {},
    "name": "InterstitialNotificationsTableArchiveMutation",
    "operationKind": "mutation",
    "text": "mutation InterstitialNotificationsTableArchiveMutation(\n  $input: NodeInput!\n) {\n  archiveInterstitialNotification(input: $input) {\n    isArchived\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "25e76e730dc9be6a5fc4512b17b141c9";

export default node;
